import script from "./batch-group-mentor-group-meeting-card.vue?vue&type=script&setup=true&lang=js"
export * from "./batch-group-mentor-group-meeting-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__